import { QueryTarget } from "@/shared/domain/query";

/**
 * Singular and plural nouns for the records a target holds.
 *
 * A `Record` keyed by the enum rather than a lookup with a fallback: adding a
 * `QueryTarget` should fail the build here, not ship a picker whose reset row
 * reads "All undefined" on the one table nobody opened before release.
 */
const NOUNS: Record<QueryTarget, { one: string; many: string }> = {
  [QueryTarget.Collections]: { one: "collection", many: "collections" },
  [QueryTarget.Datasets]: { one: "dataset", many: "datasets" },
  [QueryTarget.Devices]: { one: "device", many: "devices" },
  [QueryTarget.Events]: { one: "event", many: "events" },
  [QueryTarget.Files]: { one: "file", many: "files" },
  [QueryTarget.Sessions]: { one: "session", many: "sessions" },
  [QueryTarget.Topics]: { one: "topic", many: "topics" },
  [QueryTarget.TopicMessagePaths]: {
    one: "message path",
    many: "message paths",
  },
};

export interface ResetRowCopy {
  /** Row label, e.g. "All files". */
  title: string;
  /** Supporting line, e.g. "No filters · every file in the organization". */
  description: string;
}

/**
 * Wording for the picker's "leave the current View" row, named after what the
 * table holds — "All results" would read the same on every table in the product.
 */
export function resetRowCopy(target: QueryTarget): ResetRowCopy {
  const noun = NOUNS[target];

  return {
    title: `All ${noun.many}`,
    description: `No filters · every ${noun.one} in the organization`,
  };
}
